import React, {
    useEffect,
    useContext,
    useState,
} from "react"

import {
    ListGroup,
    Card,
    Badge,
    Button,
} from "react-bootstrap"

import PersonnelVM from "../ViewModel/Personnel.vm"
import EMETLFieldManualCell from "./Components/EMETLFieldManualCell"

import {
    Context,
} from "../Model/Contexts/AppContext"

import { 
    Rank,
    User,
} from "../API"
import EMETLPersonnelModal from "./Components/EMETLPersonnelModal"

type PersonnelProps = {
    wantsSelection?: boolean,
    doneSelecting?: (selected: string[]) => void,
    dudesAlreadySelected?: string[],
    selectionColor?: string,
    selectionHoverColor?: string,
    cellHoverColor?: string,
}

const Personnel = (props: PersonnelProps) => {
    PersonnelVM.ctx = useContext(Context)
    const {
        amplify,
        mode,
        modal: {
            setContent,
            setTitle,
        },
        personnel: {
            value: dudes,
            update: setPersonnel,
        }
    } = PersonnelVM.ctx

    const {
        wantsSelection = false,
        cellHoverColor = "rgb(242, 242, 242)",
        doneSelecting = () => {/**/},
        selectionColor = "rgb(205, 241, 244)",
        selectionHoverColor = "rgba(178, 239, 245, 1)",
        dudesAlreadySelected = [],
    } = props
    
    const [data, setData] = useState(dudes)
    const [ranks, setRanks] = useState<Rank[]>([])
    const [selectedPersonnel, setSelectedPersonnel] = useState<string[]>(dudesAlreadySelected)

    const load = async () => {
        // Use the view model functions to load data and return it (await)
        // Access state variables the user may have changed and

        const r = await PersonnelVM.loadRanks()
        if (r) {
            setRanks(r)
        }

        return await PersonnelVM.loadPersonnel() || []
    }

    const _init = async () => {
        let d = await load()
        setData(PersonnelVM.sortPersonnel(d))
        setPersonnel(d)
    }

    const refresh = async () => {
        await _init()
        // Set additional state variables here...
    }

    useEffect(() => {
        if (amplify)
            PersonnelVM.db = amplify

        _init()
    }, [amplify])

    return (
        <div>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                }}
            >
                {wantsSelection && (
                    <Button 
                        onClick={() => doneSelecting(selectedPersonnel)}
                        style={{
                            marginBottom: "10px",
                            alignSelf: "flex-end",
                        }}
                    >
                        Done Selecting Personnel ({selectedPersonnel.length})
                    </Button>
                )}
            </div>

            <Card>
                <ListGroup
                    variant="flush"
                >
                    {
                        !!data?.length && data.map((person: User) => {
                            const {
                                Name,
                                Rank,
                                ID,
                                Email,
                            } = person

                            const isSelected = selectedPersonnel?.includes(person?.ID)

                            return (
                                <EMETLFieldManualCell 
                                    key={ID}
                                    subtitle={Rank}
                                    infoFunction={null}
                                    onClick={wantsSelection ? () => {
                                        const pc = structuredClone(selectedPersonnel)
                                        if (isSelected)                                             
                                            setSelectedPersonnel(pc.filter(p => p !== person.ID))
                                        else {
                                            pc.push(person.ID)
                                            setSelectedPersonnel(pc)
                                        }
                                    } : () => {
                                        setTitle(Name)
                                        setContent(
                                            <EMETLPersonnelModal 
                                                person={person}
                                                ranks={ranks}
                                                personnelVM={PersonnelVM}
                                            />
                                        )
                                    }}
                                    style={{
                                        backgroundColor: wantsSelection && isSelected ? selectionColor : "initial",
                                    }}
                                    onHoverColor={wantsSelection && isSelected ? selectionHoverColor : cellHoverColor}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        {Name}
                                        &nbsp;-&nbsp;
                                        {Email}
                                        <div
                                            style={{
                                                alignSelf: "flex-end"
                                            }}
                                        >
                                            {Rank === "UNVERIFIED" && (
                                                <Badge
                                                    bg="secondary"
                                                >
                                                    {Rank}
                                                </Badge>
                                            )}
                                        </div>
                                    </div>
                                </EMETLFieldManualCell>
                            )
                        })
                    }
                </ListGroup>
            </Card>
        </div>

    )
}

export default Personnel
